import { Renta } from "src/gql/schema"
import { sum } from "src/shared/helpers/calculator"
import { useDate } from "src/shared/hooks/useDate"

export interface DescuentoItem {
    tipo: "Estancia" | "Extras"
    monto: number
    fecha: Date
    nombre: string
}

const useDescuentos = (ultima_renta: Renta | null | undefined) => {
    const { UTCStringToLocalDate } = useDate()

    const extrasConDescuento = (ultima_renta?.extras || []).filter(
        (extra) => extra?.descuento_aplicado
    )

    const groups = new Map<string, typeof extrasConDescuento>()
    extrasConDescuento.forEach((extra) => {
        const key = extra.venta_id ?? `no_venta_${extra.extra_id}`
        if (!groups.has(key)) groups.set(key, [])
        groups.get(key)!.push(extra)
    })

    const extrasDescuentos: DescuentoItem[] = Array.from(groups.values()).map((group) => ({
        tipo: "Extras" as const,
        monto: group.reduce(
            (acc, e) => e.descuento_aplicado?.data_descuento?.monto_calculado || 0,
            0
        ),
        fecha: UTCStringToLocalDate(group[0].descuento_aplicado?.fecha_registro),
        nombre: group[0].descuento_aplicado?.descuento?.nombre || "",
    }))

    const descuentos: DescuentoItem[] = [
        ...(ultima_renta?.descuento_aplicado
            ? [
                {
                    tipo: "Estancia" as const,
                    monto: ultima_renta.descuento_aplicado.data_descuento?.monto_calculado || 0,
                    fecha: UTCStringToLocalDate(ultima_renta.descuento_aplicado.fecha_registro),
                    nombre: ultima_renta.descuento_aplicado.descuento?.nombre || "",
                },
            ]
            : []),
        ...extrasDescuentos,
    ]

    const totalDescuento = sum(descuentos.map((d) => d.monto))

    return { descuentos, totalDescuento }
}

export default useDescuentos
